<template>
  <div class="footer">
    <!--footer-->
    <div class="page-width">
      <div class="clear">
        <div class="footerGrid footer_left">
          <h4>{{ $t('info') }}</h4>
          <ul>
            <!-- <li>
              <router-link to="/qrCode">Download the app!</router-link>
            </li> -->
            <li>
              <router-link to="/blogs">{{ $t('blog') }}</router-link>
            </li>
            <li>
              <router-link to="/contact-us">{{ $t('contact') }}</router-link>
            </li>
            <li>
              <router-link to="/about-us">{{ $t('aboutUs') }}</router-link>
            </li>
            <li>
              <router-link to="/terms-of-service">{{ $t('terms') }}</router-link>
            </li>
            <li>
              <router-link to="/privacy">{{ $t('privacyTitle') }}</router-link>
            </li>
            <li>
              <router-link to="/faq">{{ $t('FAQ') }}</router-link>
            </li>
            <li>
              <router-link to="/asian-food">{{ $t('asianFood') }}</router-link>
            </li>
          </ul>
        </div>
        <div class="footerGrid footer_right">
          <h4>{{ $t('keepInTouch') }}</h4>
          <ul class="social-icons" >
            <li>
              <a :href="companyFB" target="_blank">
                <img src="../assets/img/icon_fb_white.png" alt="">
              </a>
            </li>
            <li>
              <a :href="companyGG" target="_blank">
               <img src="../assets/img/icon_google_white.png" alt="">
              </a>
            </li>
            <li>
              <a :href="companyYT" target="_blank">
               <img src="../assets/img/icon_youtube_white.png" alt="">
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="app-qrcode">
        <h4>{{ $t('downloadApp') }}</h4>
        <ul>
          <li>
            <img src="../assets/img/app_ios.png" alt="">
            <span>ios</span>
          </li>
          <li>
            <img src="../assets/img/app_android.png" alt="">
            <span>android</span>
          </li>
        </ul>
      </div>
    </div>
    <!--end footer-->
    
    <div class="page-width">
      <img src="../assets/img/payment.png" alt="">
    </div>
  </div>
</template>

<script>           
import { Config } from '../../config/default';
import { mapState } from 'vuex'
export default {
  name: "munFooter",
  data() {
    return{
      companyFB: Config.COMPANY_FB,
      companyIG: Config.COMPANY_IG,
      companyTT: Config.COMPANY_TT,
      companyGG: Config.COMPANY_GG,
      companyYT: Config.COMPANY_YT,
    }
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn
  })
}
</script>

<style scoped lang="less">
@import "../assets/css/footer.less";
</style>



// WEBPACK FOOTER //
// src/components/munFooter.vue